module.exports = __webpack_public_path__ + "static/img/765bc712.svg";